import { useContext } from "react";
import LoadingContext from "../Context/LoadingContext";
export function useLoading() {
    const loadingHelpers = useContext(LoadingContext);
    return loadingHelpers;
}